/* eslint-disable @typescript-eslint/camelcase */
<template>
  <ul class="p-i-invested-standard-list">
    <li
      v-for="({ indexKey, heading, iconComponent },
      key) in investedStandardHeadingArray"
      :key="key"
      class="p-i-invested-standard-list__item"
      :class="`p-i-invested-standard-list__item--${key + 1}`"
    >
      <IInvestedStandardListPanel
        v-if="
          investedStandardDetail.length > 0 &&
          !(
            (investedStandardDetail[0]['kind'] == 10 ||
              investedStandardDetail[0]['kind'] == 50) &&
            indexKey == 'kind'
          )
        "
      >
        <template #heading>{{ heading }}</template>

        <template v-if="iconComponent" #content>
          <IconInvestedRounded
            :type="investedStandardDetailItem[indexKey]"
            :icon-size="48"
            :bg-color="colorCode"
          />
        </template>

        <template v-else #content>
          <span v-if="indexKey == 'kind'">
            {{ investedStandardDetailItem[indexKey] }}
          </span>
          <span
            v-else
            data-translate-skip
            :class="{
              'p-i-invested-standard-list__text': indexKey === 'text'
            }"
          >
            {{ investedStandardDetailItem[indexKey] }}
          </span>
        </template>
      </IInvestedStandardListPanel>
    </li>
  </ul>
</template>
<script lang="ts">
import IconInvestedRounded from "@/common/components/icons/IconInvestedRounded.vue";
import IInvestedStandardListPanel from "@/general/components/pages/parts/GrantCriteriaDetails/IInvestedStandardListPanel.vue";
import { Options, Vue } from "vue-class-component";
import commons from "@/common/store/modules/commons";

import { getTypeLabel } from "@/common/assets/js/utils/types";
import LocalStorage from "@/general/utils/storage";
import { mapState } from "vuex";

@Options({
  props: {
    investedStandardDetail: { type: Array, default: () => [], required: true }
  },
  components: {
    IconInvestedRounded,
    IInvestedStandardListPanel
  },
  computed: {
    ...mapState({
      storeColorCode: () => commons.colorCode
    })
  }
})
export default class IInvestedStandardList extends Vue {
  investedStandardDetail!: any[];

  unit = commons.unit;

  storeColorCode: string;

  get isGroupBudget() {
    return commons?.userInfo.groupBudgetMode;
  }

  get colorCode() {
    if (this.isGroupBudget) {
      return "#fc9014";
    }
    return this.storeColorCode;
  }

  get investedStandardDetailItem() {
    const {
      id,
      name,
      points,
      text,
      created_at,
      kind,
      grant_criteria_icon_id: icon_type
    } = this.investedStandardDetail[0];

    return {
      id,
      name,
      text,
      created_at: this.$dayjs
        .utc(created_at)
        .locale("ja")
        .format("YYYY/MM/DD"),
      points: `${points.toLocaleString()}${this.unit.point}`,
      kind: getTypeLabel(kind, true),
      icon_type
    };
  }

  get investedStandardHeadingArray() {
    return [
      {
        indexKey: "id",
        heading: "付与基準ID"
      },
      {
        indexKey: "points",
        heading: "ポイント数"
      },
      {
        indexKey: "name",
        heading: "付与基準名"
      },
      {
        indexKey: "text",
        heading: "摘要"
      },
      {
        indexKey: "icon_type",
        heading: "アイコン",
        iconComponent: true
      },
      {
        indexKey: "created_at",
        heading: "作成日"
      },
      {
        indexKey: "kind",
        heading: "ポイント種別"
      }
    ];
  }
}
</script>

<style lang="scss" scoped>
.p-i-invested-standard-list {
  @include large-pc {
    display: grid;
    gap: rem(24) cal(80, 660);
    grid-template:
      "one two" 1fr
      "three four" 1fr
      "five six" 1fr #{"/"}
      cal(290, 660) cal(290, 660);
  }

  &__item {
    min-height: rem(90);
    display: flex;
    flex-direction: column;
    justify-content: center;

    &:not(:first-child) {
      @include large-sp {
        margin-top: rem(16);
      }
    }

    &--1 {
      grid-area: one;
    }

    &--2 {
      grid-area: two;
    }

    &--3 {
      grid-area: three;
    }

    &--4 {
      grid-area: four;
    }

    &--5 {
      grid-area: five;
    }

    &--6 {
      grid-area: six;
    }
  }

  &__text {
    white-space: pre-line;
    overflow-wrap: anywhere;
  }
}
</style>
